"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconsMapping = void 0;
var _icons = require("@ori-ui/icons");
const iconsMapping = exports.iconsMapping = {
  blogger: {
    icon: _icons.BloggerRing
  },
  douban: {
    icon: _icons.Douban
  },
  email: {
    icon: _icons.EmailRing
  },
  facebook: {
    icon: _icons.Facebook
  },
  instagram: {
    icon: _icons.InstagramRing
  },
  line: {
    icon: _icons.Line
  },
  link: {
    icon: _icons.Link
  },
  messenger: {
    icon: _icons.Messenger
  },
  odnoklassniki: {
    icon: _icons.OdnoklassnikiRing
  },
  pinterest: {
    icon: _icons.Pinterest
  },
  qq: {
    icon: _icons.QqRing
  },
  qzone: {
    icon: _icons.Qzone
  },
  renren: {
    icon: _icons.Renren
  },
  rss: {
    icon: _icons.RssRing
  },
  signal: {
    icon: _icons.Signal
  },
  telegram: {
    icon: _icons.Telegram
  },
  tqq: {
    icon: _icons.TqqRing
  },
  twitter: {
    icon: _icons.XRing
  },
  viber: {
    icon: _icons.Viber
  },
  vkontakte: {
    icon: _icons.Vkontakte
  },
  wechat: {
    icon: _icons.Wechat
  },
  weibo: {
    icon: _icons.Weibo
  },
  whatsapp: {
    icon: _icons.WhatsappFilled
  },
  x: {
    icon: _icons.XRing
  },
  youku: {
    icon: _icons.Youku
  },
  youtube: {
    icon: _icons.YoutubeRing
  }
};
